<template>
    <div class="credentials-details">
      <div class="page-content">
        <img class="logo-image" :src="require(`@/assets/bank-logos/${source.logoFile}`)">
        <div class="title">
          חיבור חשבון דיסקונט בצורה מהירה ומאובטחת <span class="bold">ישירות דרך אתר דיסקונט:</span>
        </div>
        <ValidationObserver ref="observer" slim>
        <credentials-input-field class="input-container"
                                 :field-name="'של מי החשבון? (שם)'"
                                 :validations="'min-length:2'"
                                 :error="nameAlreadyUsedError"
                                 :error-message="nameAlreadyUsedErrorMessage"
                                 :field-type="'text'"
                                 :field-value="name"
                                 :update-input="updateName"/>
        <div v-for="(field, fieldKey) in source.fields" :key="fieldKey">
          <credentials-input-field v-if="field.type !== 'password'"
                                   ref="field"
                                   class="input-container"
                                   :field-name="field.name"
                                   :field-value="credentials[fieldKey]"
                                   :update-input="updateCredentials(fieldKey)"
                                   :field-type="field.type"
                                   :validations="field.validation"/>
          <credentials-input-field v-else
                                   ref="field"
                                   class="input-container"
                                   :field-name="field.name"
                                   :field-type="field.type"
                                   :field-value="credentials[fieldKey]"
                                   :validations="field.validation"
                                   :update-input="updateCredentials(fieldKey)"/>
        </div>
        </ValidationObserver>
        <div class="button-wrapper">
          <riseup-button
            class="save-button"
            :variant="'discount'"
            :disabled="!buttonEnabled"
            :title="'המשך לאתר דיסקונט'"
            :action="saveDiscountDirect"
            :size="'small'"/>
        </div>
      </div>
    </div>
</template>


<script>
import BaseUi from 'base-ui';
import _ from 'lodash';
import CredentialsInputField from '../CredentialsInputField.vue';
import ModalBus from '../../../event-bus/modal-bus';
import RedirectToDiscountPopup from './RedirectToDiscountPopup.vue';
import Segment from '../../../Segment';

export default {
  name: 'DiscountCredentialsDetails',
  components: {
    CredentialsInputField,
    RiseupButton: BaseUi.RiseupButton,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    nameAlreadyUsedError: {
      type: Boolean,
      default: false,
    },
    setNameAlreadyInUseError: {
      type: Function,
    },
    switchToRegularDiscount: {
      type: Function,
    },
    savePendingCredentials: {
      type: Function,
      required: true,
    },
    validateName: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      credentials: {},
      name: '',
      showError: false,
    };
  },
  beforeDestroy() {
    this.closeModal();
  },
  computed: {
    isValidName() {
      return this.name.length > 1;
    },
    nameAlreadyUsedErrorMessage() {
      return this.nameAlreadyUsedError ? 'כבר השתמשת בשם הזה' : null;
    },
    allFieldsHaveInput() {
      return _.every(_.keys(this.source.fields), fieldKey => this.credentials[fieldKey] && this.credentials[fieldKey].length > 3);
    },
    buttonEnabled() {
      return this.isValidName && this.allFieldsHaveInput;
    },
  },
  methods: {
    updateCredentials(fieldKey) {
      return value => {
        this.$set(this.credentials, fieldKey, value);
      };
    },
    closeModal() {
      ModalBus.$emit('close-modal');
    },
    updateName(name) {
      this.name = name;
      this.setNameAlreadyInUseError(false);
    },
    async saveDiscountDirect() {
      this.showError = true;
      Segment.trackUserInteraction('DiscountConnectClicked');
      await this.validateName({ sourceName: this.source.sourceName, name: this.name });
      const valid = await this.$refs.observer.validate();
      _.forEach(this.$refs.field, field => field.validate());
      if (valid && !this.nameAlreadyUsedError) {
        ModalBus.$emit('open', {
          component: RedirectToDiscountPopup,
          props: {
            saveDiscountCredentials: this.saveDiscountCredentials,
            idNumber: this.credentials.idNumber,
          },
        });
      }
    },
    async saveDiscountCredentials() {
      return await this.savePendingCredentials({ sourceName: this.source.sourceName, credentials: {}, name: this.name });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .credentials-details {
    width: 100%;

    .error-bar {
      @include responsive-padding;
    }

    .page-content {
      padding: 30px;
      @include responsive-padding;

      .logo-image {
        height: 40px;
        margin-bottom: 20px;
      }

      .title {
        color: $riseup_black;
        font-size: 18px;
        line-height: 1.44;
        margin-bottom: 30px;

        .bold {
          font-weight: bold;
        }
      }

      .tool-tip-wrapper {
        margin-bottom: 35px;
      }

      .input-container {
        margin-bottom: 30px;
      }

      .button-wrapper {
        .save-button {
          width: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/discount/DiscountCredentialsDetails.vue